// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import VueSingleSelect from "vue-single-select";
import 'vant/lib/index.css';
import _ from 'lodash'
import './assets/icon/iconfont.css'
import UserInfoHandle from './templates/UserInfoHandle'
import compressImg from "./utils/compressImg.js";

Vue.config.productionTip = false
Vue.component("user-info-handle", UserInfoHandle)

/**
 * 获取屏幕宽高
 */
Vue.prototype.viewportSize = {
  width: (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth),
  height: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)
}

Vue.prototype._ = _

Vue.use(Vant);

Vue.component('vue-single-select', VueSingleSelect);

Vue.prototype.$compressImg = compressImg  //注册为全局变量

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js